import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Header from "../components/Header/Header"
import { menu, menu1, menu2, menu3, menu4, tarifs } from "../mock"
import { Link } from "gatsby"
import Footer from "../components/Footer/Footer"


/**
 *
 * background-image: url(/static/players-2369e22….png);
 background-position: center 12%;
 background-repeat: no-repeat;
 background-color: transparent;
 background-size: 47%;
 mix-blend-mode: luminosity;
 width: 100%;
 *
 *
 * **/
const IndexPage = () => (
  <Layout>
    <SEO title="Nos Packs"/>

    <Header
      style={{
        maxHeight: "380px"
      }}
      withActivity={true}>
      <div className={"home-container"} style={{ marginTop: "4rem" }}>
        <div className={"home-title home-color"}>
          Nos packs
        </div>
        <div className={"home-menu"}>
          {tarifs.map((it, i) => (
            <Link to={"#" + it.url} key={"small-index-menu-" + i}>
              <div
                className={"small-menu"}
                style={{ background: it.background }}
              >
                <img
                  src={require("../images/" + it.url + ".svg")}
                  alt={it.name}
                />
                <span>{it.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Header>

    <div className={"page-container"}>
      <p className={"page-description"}>
        {"Des tarifs étudiés selon vos besoins.\n" +
        "Chaque module peut être indépendant ou lié."}
      </p>
      <div id={"essential"} className={"tarif-container"}>
        {/*<img src={require("../images/bg/bg-essential.svg")}*/}
        {/*     */}
        {/*     alt={"bg-essential"}/>*/}
        <svg preserveAspectRatio={"none"}
             className={"img-background-tarif img-background-tarif-first"}
             width="737" height="222" viewBox="0 0 737 222" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M92.593 73.7089C90.3567 44.3914 629.521 -5.59404 632.429 32.5308C635.337 70.6556 855.688 185.027 642.718 167.416C429.749 149.804 304.731 165.165 102.882 208.594C-98.9676 252.023 94.8294 103.026 92.593 73.7089Z" fill="#CAFFB7"/>
        </svg>



        <div className={"tarif-title"}>
          <h1 style={{ color: "#52C234" }}>Pack Essentiel</h1>
          <h3>Deux formules au choix pour démarrer votre activité</h3>
        </div>
        <div className={"tarif-price"}>
          <svg
            preserveAspectRatio={"none"}
            className={"img-background-price"}
            width="207" height="215" viewBox="0 0 207 215" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M136.381 53.1341C153.893 132.06 185.685 122.696 156.468 151.029C127.25 179.362 92.4712 197.975 60.3946 178.539C28.3179 159.103 27.4101 123.353 40.3077 80.6443C53.2054 37.9357 118.869 -25.7919 136.381 53.1341Z"
              fill="url(#paint0_linear)"/>
            <defs>
              <linearGradient id="paint0_linear" x1="46.9786" y1="69.6349" x2="165.211" y2="141.275"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#5DC641"/>
                <stop offset="1" stopColor="#22FB74"/>
              </linearGradient>
            </defs>
          </svg>

          {/*<img src={require("../images/bg/bg-essential-price.svg")}*/}
          {/*     className={"img-background-price"}*/}
          {/*     alt={"bg-essential"}/>*/}
          <div className={"tarif-price-container"}>
            <img src={require("../images/essential.svg")} alt={"Essentiel"}/>
            <div className={"tarif-price-info"}>
              <h1>99</h1>
              <h2>€</h2>
            </div>
            <h4>/mois</h4>
          </div>

        </div>
      </div>

      <div className={"essential-container"}>
        <p>A vous de choisir la formule qui vous convient le mieux.</p>
        <div className={"essential-page-container"}>
          <div className={"essential-page"}>
            <div className={"essential-top"}>
              <div className={"essential-img"}>
                <img src={require("../images/bg/planning-side.png")} alt={"planning"}/>
              </div>
              <div className={"essential-side"}>
                {menu1.map((it, i) => {
                  return (
                    <div
                      key={it.url}
                      className={"small-menu"}
                      style={{ background: it.background }}
                    >
                      <img
                        src={require("../images/" + it.url + ".svg")}
                        alt={it.name}
                      />
                      <span>{it.name}</span>
                    </div>
                  )

                })}
              </div>
            </div>
            <div className={"essential-bottom"}>
              <p>Axé sur la réservation, vous pourrez tout personnaliser selon vos besoins :</p>
              <p>- nom des terrains,</p>
              <p>- type d’activité (foot, padel, anniversaire)</p>
              <p>- gestion des prix selon les heures (pleine, creuse ...)</p>
              <p>
                - réservation en ligne ....
              </p>
            </div>
          </div>
          <span> OU </span>
          <div className={"essential-page essential-right"}>
            <div className={"essential-top"}>
              <div className={"essential-side"}>
                {menu2.map((it, i) => {
                  return (
                    <div
                      className={"small-menu"}
                      style={{ background: it.background }}
                    >
                      <img
                        src={require("../images/" + it.url + ".svg")}
                        alt={it.name}
                      />
                      <span>{it.name}</span>
                    </div>
                  )

                })}
              </div>
              <div className={"essential-img"}>
                <img src={require("../images/bg/caisse-side.png")} alt={"planning"}/>
              </div>

            </div>
            <div className={"essential-bottom"}>
              <p>
                La caisse spécialement conçu pour gérer les flux spécifiques des centres
                sportifs et
                loisirs :
              </p>
              <p>
                - activité multi joueur
              </p>
              <p>
                - paiement par participant
              </p>
              <p>
                - acompte, crédit
              </p>
            </div>
          </div>
        </div>

      </div>


      <div id={"senerte"} className={"tarif-container"}>
        {/*<img src={require("../images/bg/bg-senerite.svg")}*/}
        {/*     className={"img-background-tarif img-background-tarif-second"}*/}
        {/*     alt={"bg-essential"}/>*/}
        <svg
          preserveAspectRatio={"none"}
          className={"img-background-tarif img-background-tarif-second"}
          width="613" height="172" viewBox="0 0 613 172" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M81.9149 17.3244C83.011 -10.7635 539.873 -1.38566 538.448 35.1401C537.022 71.6658 710.081 203.56 533.405 164.367C356.729 125.175 250.413 126.583 76.8719 146.552C-96.6695 166.521 80.8188 45.4122 81.9149 17.3244Z" fill="#5754F5" fill-opacity="0.2"/>
        </svg>


        <div className={"tarif-price left-price"}>
          {/*<img src={require("../images/bg/side-senerite.svg")}*/}
          {/*     className={"img-background-price"}*/}
          {/*     alt={"bg-essential"}/>*/}

          <svg
            preserveAspectRatio={"none"}
            className={"img-background-price"}
            width="179" height="229" viewBox="0 0 179 229" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.5045 129.22C-10.4127 93.5761 56.3476 -5.21983 94.8336 5.70335C133.32 16.6265 167.411 40.5177 170.469 88.9244C173.526 137.331 112.119 219.692 73.4044 222.137C14.9034 243.377 31.4217 164.863 10.5045 129.22Z"
              fill="url(#paint1_linear)"/>
            <defs>
              <linearGradient id="paint1_linear" x1="93.8895" y1="179.981" x2="82.6212" y2="1.55668"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#84669F"/>
                <stop offset="1" stopColor="#B7B6FF" stopOpacity="0.67"/>
              </linearGradient>
            </defs>
          </svg>


          <div className={"tarif-price-container"}>
            <img src={require("../images/senerte.svg")} alt={"Essentiel"}/>
            <div className={"tarif-price-info"}>
              <h1>179</h1>
              <h2>€</h2>
            </div>
            <h4>/mois</h4>
          </div>

        </div>
        <div className={"tarif-title"}>
          <h1 style={{ color: "#876BA4" }}>Pack Sérénité</h1>
          <h3 style={{ color: "#876BA4" }}>Toutes les fonctionnalités sans compromis</h3>
        </div>
      </div>

      <div className={"essential-container serenite-container"}>
        <div className={"p_handle"}>
          <p>
            Optez pour la tranquillité avec les deux formules essentielles réunit.<br/><br/>

            Une interaction sans précédent entre la réservation et l’encaissement.<br/>
            Tout est relié pour vous faire gagnez du temps et de l’argent.

          </p>
        </div>

        <div className={"essential-page-container"}>
          <div className={"essential-page"}>
            <div className={"essential-side row"}>
              {menu3.map((it, i) => {
                return (
                  <div
                    className={"small-menu"}
                    style={{ background: it.background }}
                  >
                    <img
                      src={require("../images/" + it.url + ".svg")}
                      alt={it.name}
                    />
                    <span>{it.name}</span>
                  </div>
                )

              })}
            </div>
          </div>
        </div>
      </div>


      <div id={"play"} className={"tarif-container"}>
        {/*<img src={require("../images/bg/bg-video.svg")}*/}
        {/*     alt={"bg-essential"}/>*/}

        <svg
          preserveAspectRatio={"none"}
          className={"img-background-tarif  img-background-tarif-third"}
          width="662" height="181" viewBox="0 0 662 181" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M82.9825 34.8049C82.3881 11.8545 573.287 -7.75965 574.06 22.0853C574.833 51.9302 768.875 149.069 576.795 127.676C384.714 106.283 270.704 113.773 85.7175 140.396C-99.2694 167.019 83.577 57.7553 82.9825 34.8049Z" fill="#FE4723" fill-opacity="0.2"/>
          <path d="M545.298 92.4749C479.452 162.54 515.368 190.921 480.649 177.95C445.93 164.979 416 139.681 416 92.4749C416 45.2684 444.944 7 480.649 7C516.353 7 611.144 22.4099 545.298 92.4749Z" fill="url(#paint0_linear)"/>
          <path d="M433.189 78.6691H439.032C439.136 77.2698 439.836 75.8705 441.76 75.8705C443.369 75.8705 444.384 76.815 444.384 78.5291C444.384 80.838 442.425 81.3278 440.396 81.3278H439.276V86.1904H440.396C443.509 86.1904 444.874 87.0999 444.874 89.3738C444.874 91.0529 443.859 92.2424 442.005 92.2424C439.801 92.2424 438.717 90.913 438.682 88.919H432.875C433.05 94.6911 436.898 97.2099 442.215 97.2099C447.567 97.2099 450.646 94.1314 450.646 89.8285C450.646 86.4702 448.897 84.5112 446.343 83.6716V83.5317C448.092 82.937 450.191 81.1528 450.191 77.7945C450.191 73.9464 447.287 70.8679 441.9 70.8679C436.688 70.8679 433.399 73.6316 433.189 78.6691ZM455.07 89.5137C455.35 93.4318 458.044 97.1049 463.606 97.1049C470.462 97.1049 472.491 92.2773 472.491 83.5667C472.491 75.8005 470.462 70.8679 463.186 70.8679C457.764 70.8679 454.405 74.2263 454.405 79.4037C454.405 84.826 457.764 87.5547 462.137 87.5547C464.305 87.5547 466.194 86.7151 467.209 85.2808C467.209 90.1434 466.334 92.2773 463.816 92.2773C461.962 92.2773 460.947 91.2978 460.597 89.5137H455.07ZM463.501 82.832C461.157 82.832 460.038 81.3977 460.038 79.4737C460.038 77.3397 461.297 76.0104 463.361 76.0104C465.39 76.0104 466.719 77.2348 466.719 79.5087C466.719 81.5726 465.46 82.832 463.501 82.832ZM475.256 92.0744C475.256 92.2004 475.256 92.3263 475.27 92.4523H474.389V93.6976H475.48C476.082 95.7406 477.845 97.07 480.182 97.07C482.519 97.07 484.282 95.7686 484.841 93.6417H482.211C481.805 94.4533 481.063 94.887 480.154 94.887C479.23 94.887 478.489 94.4533 478.069 93.6976H480.434V92.4523H477.705C477.691 92.3263 477.691 92.2004 477.691 92.0744C477.691 91.9345 477.691 91.7946 477.705 91.6686H480.434V90.4093H478.097C478.517 89.6956 479.244 89.2758 480.154 89.2758C481.063 89.2758 481.805 89.6956 482.211 90.5072H484.841C484.282 88.3803 482.519 87.0649 480.182 87.0649C477.859 87.0649 476.11 88.3803 475.494 90.4093H474.389V91.6686H475.27C475.256 91.7946 475.256 91.9345 475.256 92.0744Z" fill="white"/>
          <path d="M444.573 113.665H445.454L448.138 102.773H447.247L444.573 113.665ZM457.214 112H458.096V108.836C458.096 107.298 457.146 106.534 455.921 106.534C455.099 106.534 454.335 106.955 454.021 107.729C453.669 106.926 452.934 106.534 452.052 106.534C451.347 106.534 450.71 106.838 450.358 107.406V106.632H449.466V112H450.358V109.042C450.358 107.886 450.975 107.308 451.876 107.308C452.758 107.308 453.345 107.866 453.345 108.964V112H454.227V109.042C454.227 107.886 454.844 107.308 455.745 107.308C456.627 107.308 457.214 107.866 457.214 108.964V112ZM464.652 109.306C464.652 107.612 463.466 106.544 461.938 106.544C460.42 106.544 459.225 107.612 459.225 109.306C459.225 111.011 460.381 112.088 461.899 112.088C463.427 112.088 464.652 111.011 464.652 109.306ZM460.136 109.306C460.136 107.955 460.988 107.318 461.929 107.318C462.849 107.318 463.741 107.955 463.741 109.306C463.741 110.668 462.83 111.305 461.899 111.305C460.969 111.305 460.136 110.668 460.136 109.306ZM465.824 112H466.715V106.632H465.824V112ZM466.284 105.76C466.607 105.76 466.872 105.496 466.872 105.153C466.872 104.81 466.607 104.546 466.284 104.546C465.941 104.546 465.677 104.81 465.677 105.153C465.677 105.496 465.941 105.76 466.284 105.76ZM472.093 110.541C472.054 108.621 468.939 109.316 468.939 108.043C468.939 107.612 469.331 107.298 469.987 107.298C470.702 107.298 471.114 107.69 471.153 108.229H472.044C471.986 107.181 471.202 106.544 470.017 106.544C468.822 106.544 468.048 107.22 468.048 108.043C468.048 110.041 471.222 109.346 471.222 110.541C471.222 110.981 470.83 111.334 470.125 111.334C469.37 111.334 468.91 110.942 468.861 110.423H467.94C467.999 111.402 468.881 112.088 470.134 112.088C471.32 112.088 472.093 111.422 472.093 110.541Z" fill="#F2F2F2"/>
          <path d="M462 54C470.284 54 477 47.2843 477 39C477 30.7157 470.284 24 462 24C453.716 24 447 30.7157 447 39C447 47.2843 453.716 54 462 54Z" fill="#FFC265"/>
          <path d="M462 52.367C453.99 52.367 447.446 46.088 447.022 38.1835C447.008 38.4539 447 38.7261 447 39C447 47.2843 453.716 54 462 54C470.284 54 477 47.2843 477 39C477 38.7261 476.992 38.4539 476.978 38.1835C476.554 46.088 470.01 52.367 462 52.367Z" fill="#FFB541"/>
          <path d="M462 51.5679C468.941 51.5679 474.568 45.9411 474.568 39C474.568 32.0589 468.941 26.432 462 26.432C455.059 26.432 449.432 32.0589 449.432 39C449.432 45.9411 455.059 51.5679 462 51.5679Z" fill="#FFE9C8"/>
          <path d="M462 49.9349C455.333 49.9349 449.88 44.7439 449.459 38.1835C449.442 38.4536 449.432 38.7256 449.432 39.0001C449.432 45.9412 455.059 51.568 462 51.568C468.941 51.568 474.568 45.9411 474.568 39C474.568 38.7256 474.558 38.4535 474.541 38.1835C474.12 44.7439 468.667 49.9349 462 49.9349V49.9349Z" fill="#FFDCA7"/>
          <path d="M459.617 44.7754L467.498 39.7843C468.074 39.4198 468.074 38.5801 467.498 38.2156L459.617 33.2245C458.999 32.833 458.192 33.2771 458.192 34.0088V43.9911C458.192 44.7228 458.999 45.167 459.617 44.7754V44.7754Z" fill="#FF4755"/>
          <path d="M467.498 38.6957L459.617 43.6867C458.999 44.0783 458.192 43.6341 458.192 42.9024V43.9911C458.192 44.7229 458.999 45.167 459.617 44.7755L467.498 39.7843C467.969 39.486 468.054 38.8695 467.754 38.4556C467.687 38.5474 467.602 38.6295 467.498 38.6957V38.6957Z" fill="#FC2B3A"/>
          <path d="M435.786 63.9395C435.786 64.6912 436.252 65.1695 436.833 65.1695C437.187 65.1695 437.439 65.0072 437.571 64.7979V65.1353H438.302V62.7523H437.571V63.0897C437.443 62.8804 437.191 62.7181 436.837 62.7181C436.252 62.7181 435.786 63.1879 435.786 63.9395ZM437.571 63.9438C437.571 64.3239 437.328 64.5332 437.05 64.5332C436.777 64.5332 436.529 64.3196 436.529 63.9395C436.529 63.5595 436.777 63.3545 437.05 63.3545C437.328 63.3545 437.571 63.5637 437.571 63.9438ZM436.598 62.1587L437.627 62.59V62.0861L436.598 61.5907V62.1587ZM440.465 63.0897V62.7523H439.735V66.2713H440.465V64.8022C440.598 65.0029 440.85 65.1695 441.2 65.1695C441.785 65.1695 442.25 64.6912 442.25 63.9395C442.25 63.1879 441.785 62.7181 441.2 62.7181C440.85 62.7181 440.598 62.8804 440.465 63.0897ZM441.507 63.9395C441.507 64.3196 441.26 64.5332 440.982 64.5332C440.709 64.5332 440.461 64.3239 440.461 63.9438C440.461 63.5637 440.709 63.3545 440.982 63.3545C441.26 63.3545 441.507 63.5595 441.507 63.9395ZM442.488 63.9395C442.488 64.6912 442.954 65.1695 443.535 65.1695C443.889 65.1695 444.141 65.0072 444.273 64.7979V65.1353H445.004V62.7523H444.273V63.0897C444.145 62.8804 443.893 62.7181 443.539 62.7181C442.954 62.7181 442.488 63.1879 442.488 63.9395ZM444.273 63.9438C444.273 64.3239 444.03 64.5332 443.752 64.5332C443.479 64.5332 443.231 64.3196 443.231 63.9395C443.231 63.5595 443.479 63.3545 443.752 63.3545C444.03 63.3545 444.273 63.5637 444.273 63.9438ZM446.262 64.0292C446.262 63.6192 446.463 63.4997 446.809 63.4997H447.01V62.7267C446.689 62.7267 446.429 62.8975 446.262 63.1495V62.7523H445.532V65.1353H446.262V64.0292ZM447.474 64.3068C447.474 64.9261 447.82 65.1353 448.315 65.1353H448.687V64.5161H448.426C448.264 64.5161 448.204 64.4563 448.204 64.3154V63.3587H448.683V62.7523H448.204V62.1715H447.474V62.7523H447.184V63.3587H447.474V64.3068ZM449.094 65.1353H449.824V62.7523H449.094V65.1353ZM449.461 62.5046C449.717 62.5046 449.892 62.3295 449.892 62.1117C449.892 61.8896 449.717 61.7146 449.461 61.7146C449.2 61.7146 449.025 61.8896 449.025 62.1117C449.025 62.3295 449.2 62.5046 449.461 62.5046ZM451.083 64.0292C451.083 63.6192 451.284 63.4997 451.63 63.4997H451.831V62.7267C451.51 62.7267 451.25 62.8975 451.083 63.1495V62.7523H450.353V65.1353H451.083V64.0292ZM452.94 63.9395C452.94 64.6912 453.405 65.1695 453.99 65.1695C454.34 65.1695 454.592 65.0115 454.725 64.7937V65.1353H455.455V61.9751H454.725V63.0811C454.58 62.8633 454.306 62.7181 453.99 62.7181C453.405 62.7181 452.94 63.1879 452.94 63.9395ZM454.725 63.9438C454.725 64.3239 454.481 64.5332 454.204 64.5332C453.93 64.5332 453.683 64.3196 453.683 63.9395C453.683 63.5595 453.93 63.3545 454.204 63.3545C454.481 63.3545 454.725 63.5637 454.725 63.9438ZM457.034 63.3032C457.277 63.3032 457.482 63.4527 457.482 63.7132H456.568C456.611 63.4484 456.795 63.3032 457.034 63.3032ZM458.174 64.3453H457.397C457.337 64.4734 457.222 64.5759 457.017 64.5759C456.782 64.5759 456.59 64.4307 456.564 64.1189H458.217C458.225 64.0463 458.23 63.9737 458.23 63.9054C458.23 63.1794 457.739 62.7181 457.042 62.7181C456.334 62.7181 455.838 63.1879 455.838 63.9438C455.838 64.6997 456.342 65.1695 457.042 65.1695C457.636 65.1695 458.059 64.8107 458.174 64.3453Z" fill="white"/>
          <defs>
            <linearGradient id="paint0_linear" x1="480.948" y1="-2.31244" x2="533.341" y2="103.451" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FF512F"/>
              <stop offset="1" stopColor="#F09819" stopOpacity="0.6"/>
            </linearGradient>
          </defs>
        </svg>

        <div className={"tarif-title"}>
          <h1 style={{ color: "#FF512F" }}>Pack vidéo</h1>
          <h3 style={{ color: "#FF512F" }}>Système vidéo automatisé</h3>
        </div>
        <div className={"tarif-price video-price"}>
          {/*<img src={require("../images/bg/side-video.svg")}*/}
          {/*     className={"img-background-price img-bg-video"}*/}
          {/*     alt={"bg-essential"}/>*/}
          <svg
            preserveAspectRatio={"none"}
            className={"img-background-price img-bg-video"}
            width="152" height="174" viewBox="0 0 152 174" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M129.298 85.4749C63.4517 155.54 99.3677 183.921 64.6489 170.95C29.93 157.979 0 132.681 0 85.4749C0 38.2684 28.9443 0 64.6489 0C100.353 0 195.144 15.4099 129.298 85.4749Z"
              fill="url(#paint3_linear)"/>
            <defs>
              <linearGradient id="paint3_linear" x1="64.9482" y1="-9.31244" x2="117.341" y2="96.4506"
                              gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF512F"/>
                <stop offset="1" stopColor="#F09819" stopOpacity="0.6"/>
              </linearGradient>
            </defs>
          </svg>


          <img className={"video-icon"}
               style={{}}
               src={require("../images/play.svg")} alt={"Essentiel"}/>
          <div className={"tarif-price-container"}>

            <span>à partir de </span>
            <div className={"tarif-price-info"}>
              <h1>39</h1>
              <h2>€</h2>
            </div>
            <h4>/mois</h4>
          </div>

        </div>
      </div>

      <div className={"pack-video-container"}>
        <div className={"essential-container serenite-container"}>
          <div className={"p_handle"}>
            <p>
              Accédez à la vidéo et au scoring à moindre coût.<br/>
              Après un audit nous vous donnerons<br/>
              les meilleures solutions selon vos besoins :<br/>
              - live, replay, diffusion dans le club house ...<br/>
              - gestion du score, type de tablette, connexion  ....<br/>
              <br/>

            </p>
          </div>

          <div className={"essential-page-container"}>
            <div className={"essential-page"}>

              <div className={"essential-side row"}>
                <img src={require("../images/content/camera1.svg")}
                     id={"tarif-camera"}
                     alt={"calendar"}/>
                {menu4.map((it, i) => {
                  return (
                    <div
                      className={"small-menu"}
                      style={{ background: it.background }}
                    >
                      <img
                        src={require("../images/" + it.url + ".svg")}
                        alt={it.name}
                      />
                      <span>{it.name}</span>
                    </div>
                  )

                })}

              </div>

            </div>
          </div>
        </div>
        <div className={"essential-img"}>
          <img src={require("../images/new/video-pack.png")}
               style={{ width: 600, height: 400, zIndex: 100 }}
               alt={"planning"}/>
        </div>
      </div>

      <div className={"table-container"}>
        <img alt={"bg"}
             style={{
               position: "absolute",
               width: "100%"
             }}
             src={require("../images/bg/bg-table.svg")}
        />
        <h3 style={{ marginBottom: "2rem" }}>Tableau récapitulatif</h3>
        <div className={"table-content"}>
          <div className={"table-item"} style={{
            background: " linear-gradient(180deg, #398126 0%, #3CD213 100%)",
            width: "calc(100%/3 - 2rem)"
          }}>
            <div className={"table-head"}>
              <img alt={""} src={require("../images/essential.svg")} style={{ width: 68, height: 68 }}/>
              <h2>Essentiel</h2>
              <hr style={{ color: "white", backgroundColor: "white" }}/>
            </div>

            <div className={"table-body"}>
              <div className={"table-price"}>
                <h3>99</h3>
                <h4>€</h4>
                <h6>/mois</h6>
              </div>
              <div className={"table-first"}>
                <h6>Au choix</h6>
                <span className={"tab-number"}>1</span>
                <div className={"tab-menu"}>
                  <span style={{ fontWeight: "bold" }}>Planning de réservation</span>
                  <span>CRM Client, Réservation...</span>
                  <span>Championnat</span>
                  <span>Application Manager</span>
                  <span>Application Booking</span>
                </div>
              </div>
              <h4>OU</h4>
              <div className={"table-first"}>
                <h6/>
                <span className={"tab-number"}>2</span>
                <div className={"tab-menu"}>
                  <span>Caisse</span>
                  <span>Gestion des abonnements</span>
                  <span>CRM client</span>
                  <span>Paiement en ligne</span>
                </div>
              </div>
            </div>
            {/*<button className={"btn-choose"}>Choisir</button>*/}
          </div>


          <div className={"table-item"} style={{
            background: " linear-gradient(180deg, #8824ED 0%, #B872FF 100%)",
            boxShadow: "0px 4px 30px #FFFFFF",
            width: "calc(100%/3 - 2rem)",
            transform: "scale(1.01)",
            zIndex: 8000
          }}>
            <div className={"table-head"}>
              <img alt={""} src={require("../images/senerte.svg")} style={{ width: 68, height: 68 }}/>
              <h2>Sérénité</h2>
              <hr style={{ color: "white", backgroundColor: "white" }}/>
            </div>

            <div className={"table-body"}>
              <div className={"table-price"}>
                <h3>179</h3>
                <h4>€</h4>
                <h6>/mois</h6>
              </div>
              <div className={"table-first"}>
                <h6>Soyez tranquille</h6>
                <span className={"tab-number"}>1</span>
                <div className={"tab-menu"}>
                  <span style={{ fontWeight: "bold" }}>Planning de réservation</span>
                  <span>CRM Client, Réservation...</span>
                  <span>Championnat</span>
                  <span>Application Manager</span>
                  <span>Application Booking</span>
                </div>
              </div>
              <h4>+</h4>
              <div className={"table-first"}>
                <h6/>
                <span className={"tab-number"}>2</span>
                <div className={"tab-menu"}>
                  <span>Caisse</span>
                  <span>Gestion des abonnements</span>
                  <span>CRM client</span>
                  <span>Paiement en ligne</span>
                </div>
              </div>
            </div>
            {/*<button*/}
            {/*  style={{ backgroundColor: "#8824ED" }}*/}
            {/*  className={"btn-choose"}>Choisir*/}
            {/*</button>*/}
          </div>


          <div className={"table-item"} style={{
            background: "linear-gradient(180deg, #FD6136 0%, #F89653 100%)",
            width: "calc(100%/3 - 2rem)"
          }}>
            <div className={"table-head"}>
              <img alt={""} src={require("../images/play.svg")} style={{ width: 68, height: 68 }}/>
              <h2>Vidéo</h2>
              <hr style={{ color: "white", backgroundColor: "white" }}/>
            </div>

            <div className={"table-body"}>
                            <span
                              className={"partir-p"}
                              style={{
                              width: "92%",
                              marginBottom: "-0.42rem",
                              marginTop: "2rem",

                            }}>à partir de</span>
              <div className={"table-price"}>
                <h3>39</h3>
                <h4>€</h4>
                <h6>/mois</h6>
              </div>
              <div className={"table-first"}>
                <h6>Innovez</h6>
                <span className={"tab-number no-border"}/>
                <div className={"tab-menu"}>
                  <span style={{ fontWeight: "bold" }}>Live   <b>&</b>   Replay</span>
                  <span>Application Scorepad</span>
                  <span>Séquencage des buts</span>
                  <span>Diffusion dans le club house</span>
                  <span/>
                </div>
              </div>
              <h4></h4>
              <div className={"table-first"}>
                <h6/>
                <span className={"tab-number no-border"}/>
                <div className={"tab-menu"}>
                  <span>Tarif dégressif</span>
                  <span>Installation sur devis</span>
                  <span/>
                  <span>Prix hors matériel</span>
                </div>
              </div>
            </div>
            {/*<button*/}
            {/*  style={{ backgroundColor: "#E8560E" }}*/}
            {/*  className={"btn-choose"}>Choisir*/}
            {/*</button>*/}
          </div>


        </div>
      </div>


      <button className={"btn-demo"}>Demandez une démonstration</button>


    </div>

    <Footer>
      <div className={"home-menu"}>
        {
          menu.map((it, i) => (
            <Link to={"#" + it.url} key={"small-index-menu-" + i}>
              <div
                className={"small-menu"}
                style={{ background: it.background }}
              >
                <img
                  src={require("../images/" + it.url + ".svg")}
                  alt={it.name}
                />
                <span>{it.name}</span>
              </div>
            </Link>
          ))
        };
      </div>
    </Footer>
  </Layout>
)

export default IndexPage
